export default {
  the_protocol_title: '协议',
  the_protocol_1: '自动扣款授权服务协议',
  the_protocol_2: '版本：2024年11月',
  new_protocol_4:
    '自动扣款授权服务协议（以下简称“本协议”）是Bluepay用户（以下简称“用户”或“您”）与Bluepay Company Limited（注册号：0105559091404，以下简称“Bluepay”）之间就自动扣款支付服务授权及其他相关事宜订立的有效合同。您通过网页点击确认或其他验证程序接受本协议，即表示您与Bluepay已达成协议，并同意接受本协议的全部约定内容。在接受本协议之前，请仔细阅读本协议的全部内容。如果您不同意本协议的任何内容，或无法准确理解Bluepay对条款和条件的解释，请不要继续后续操作。如果您对本协议有任何疑问，请通过Bluepay客服咨询，Bluepay客服将乐意为您服务并进行解释。',
  title_new_protocol_6: '1. 服务介绍',
  new_protocol_7:
    '支付授权服务（以下简称“服务”）：指您授权特定第三方发送扣款指令至Bluepay，并授权Bluepay根据该特定第三方的指令在其客户端向其他支付渠道发送扣款指令，或授权Bluepay将扣款指令传递给其客户端的其他支付渠道服务提供商（以下简称“支付渠道服务提供商”）。该服务授权Bluepay根据您的授权，从您的Bluepay账户或其他支付渠道中扣除指定金额，并将该款项划转至该特定第三方指定的账户。此外，该服务还包括Bluepay基于您事先授权，在满足条件时直接从您的Bluepay账户中扣除指定金额，或将扣款指令传递给其他支付渠道服务提供商，从相应支付渠道中扣除指定金额至指定账户的情况。具体服务情形和服务内容，请参见对应服务页面的描述。',
  new_protocol_8:
    '除上述约定外，该服务还包括：在满足相关条件的情况下，Bluepay可根据您此前的授权，直接从您的Bluepay账户中扣除指定金额，或将扣款指令传递至其他支付渠道的服务提供商，从相应的支付渠道中扣除指定金额至指定账户。具体服务情形及内容请参见相关服务页面中的说明。',
  title_new_protocol_9: '2. 陈述与保证',
  new_protocol_10:
    '2.1 您确认使用服务是基于您真实意愿；同时，您负责在使用服务过程中发出指令的真实性与有效性，该等指令被视为您真实意图的体现，且不可变更或撤销。您理解Bluepay按照您的指令操作所产生的风险由您承担。',
  new_protocol_11:
    '2.2 您承诺不会使用服务从事任何非法活动，或违反本协议目的，或侵犯其他第三方的权益，否则Bluepay有权单方面终止提供服务；如您给Bluepay造成损失，您应依法承担相应责任。',
  new_protocol_12:
    '2.3 您授权特定第三方发送扣款指令至Bluepay，并授权Bluepay根据该特定第三方的指令从您的Bluepay账户或其他“Bluepay”客户端支付渠道中扣除指定金额至该特定第三方指定的账户，或授权Bluepay将扣款指令传递给其他支付渠道服务主体。您理解并确认，您授权的特定第三方包括向您提供服务的商户、由商户和您共同确认的第三方，或在您未能及时足额支付款项时，依法对您享有追偿权的保险公司（如有）。',
  new_protocol_13:
    '2.4 在使用服务过程中，除非另有约定，您可使用Bluepay客户端的支付渠道，包括Bluepay账户余额或其他支付渠道，这些支付渠道由收款方实际支持并由您选择。',
  new_protocol_14:
    '2.5 如果您已自行设置支付顺序，Bluepay将按照您设置的支付顺序为您提供服务，除非您授权或同意的场景，银行卡及其他资金渠道响应超时或扣款失败；如果您未设置支付顺序，为给您提供良好的支付体验，Bluepay可按照您的支付习惯为您提供服务；您可随时在“Bluepay”页面设置支付顺序。Bluepay可根据您的支付习惯为您提供服务，如果您未设置支付顺序；您可在“Bluepay”客户端随时设置支付顺序。',
  new_protocol_15:
    '2.6 您理解并同意，Bluepay仅为授权指令的执行方或信息传递方，除非Bluepay未按照特定第三方指令或您的授权进行操作或信息传递，或操作或传递指令错误，否则Bluepay对由此服务产生的损失免责。该等损失和责任应由您与特定第三方协商解决或由您承担责任。',
  new_protocol_16:
    '2.7 您理解并同意，基于风险防控，Bluepay或其他支付渠道服务提供商将对您选择的不同支付渠道的支付金额进行差异化控制，且每日支付授权限额及每日授权次数以具体公告为准。如超过限额，您可能无法使用服务完成扣款。',
  new_protocol_17:
    '2.8 Bluepay重视您的隐私保护，并严格依照Bluepay隐私政策保护和处理您的私密信息。在使用服务过程中，您可能需同时使用第三方提供的其他服务。',
  new_protocol_18:
    '2.9 除法律另有规定或本协议另有约定外，Bluepay可通过公告或其他提醒方式提前通知您单方面终止向您提供服务，并免责。Bluepay终止提供服务后，如发现您违反法律或本协议目的，给Bluepay造成损失，Bluepay仍有权要求您依法承担相应责任。您可根据“Bluepay”客户端的支付设置指南或通过Bluepay客服热线申请提前终止服务。但您理解并同意，为维护您和其他用户的合法权益，您申请终止服务或终止对特定第三方的支付授权可能需满足一定条件（例如，不存在未完成的交易订单或其他未结支付授权）。',
  new_protocol_19:
    '2.10 Bluepay及其他支付渠道服务提供商将通过“Bluepay”客户端推送消息、账单或手机短信向您展示扣款所涉交易信息。',
  title_new_protocol_20: '3. 其他',
  new_protocol_21:
    '3.1 为持续提升用户体验，我们将不断更新服务，为您提供版本升级、功能升级、规则升级及其他服务和内容更新，本协议亦可能相应更新。我们将通过公告、客户端通知、短信或弹窗（合称“通知”）方式告知您协议更新内容，更新自通知指定日期起生效。如您不同意更新后的条款和条件，有权停止使用相关服务；双方也可经协商一致变更相关服务及对应条款和条件。',
  new_protocol_22:
    '3.2 本协议的订立、执行、履行和解释均适用泰国法律。双方同意，因本协议产生或与双方关系相关的任何争议，仅在泰国法院解决，不受其他司法管辖区管辖。因本协议的违反、终止或有效性产生或相关的任何争议、争议或索赔，双方同意按照泰国适用法律解决，并由泰国法院管辖。',
  new_protocol_23:
    '3.3 本协议的订立、执行、履行和解释适用泰国法律；法律未明确规定时，适用Bluepay制定的业务规则和通行商业惯例。本协议未约定部分，按“BluePay用户服务条款”及相关规则履行；本协议与“BluePay用户服务条款”及相关规则冲突时，以本协议为准。'
}
